"use client";

import { useAppContext } from "@/context/AppContext";
import { SubvraagResponse, VraagIdentifier } from "@/services/api_types";
import { useEffect, useState } from "react";

export interface NativeBookmark {
  vraagId?: number;
  subvraagLetter?: string;
}

export default function useNativeBookmark(
  currentVraag?: VraagIdentifier,
  currentSubvraag?: SubvraagResponse
) {
  const { nativeBookmark, setNativeBookmark } = useAppContext();

  useEffect(() => {
    setNativeBookmark((prev) => {
      return {
        ...prev,
        vraagId: currentVraag?.id,
        subvraagLetter: currentSubvraag?.letter
      };
    });
  }, [currentVraag, currentSubvraag]);
}
